import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ae3c9c98"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-2" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Unidade", -1))
const _hoisted_3 = ["id", "value"]
const _hoisted_4 = ["for"]
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "label-allunits",
  for: "all"
}, "Todas as Unidades", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("ul", {
      id: "dropItem",
      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.eventStop && _ctx.eventStop(...args)))
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listFilter, (checked) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "d-flex align-items-center",
          key: checked.text,
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.eventStop && _ctx.eventStop(...args)))
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            class: "checked-input",
            id: checked.text,
            value: checked.text,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedValue) = $event)),
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changeUnit && _ctx.changeUnit(...args)))
          }, null, 40, _hoisted_3), [
            [_vModelCheckbox, _ctx.selectedValue]
          ]),
          _createElementVNode("label", {
            for: checked.text,
            class: "mt-1"
          }, _toDisplayString(checked.text), 9, _hoisted_4)
        ]))
      }), 128)),
      _createElementVNode("li", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          class: "checked-input",
          id: "all",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isCheck) = $event)),
          onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.changeAllUnits && _ctx.changeAllUnits(...args)))
        }, null, 544), [
          [_vModelCheckbox, _ctx.isCheck]
        ]),
        _hoisted_6
      ])
    ])
  ]))
}